import { CommonRegistry } from '@common/components/components';

import { World } from '../World';
import { CombatService } from './CombatService';
import { EventBusService } from './EventBusService';
import { GameTimeService } from './GameTimeService';
import { InputService } from './InputService';
import { MapDataService } from './MapDataService';
import { MessageQueueService } from './MessageQueueService';
import { SimulationService } from './SimulationService';
import { SpeedService } from './SpeedService';
import { TerrainService } from './TerrainService';
import { WorldService } from './WorldService';

/**
 * Service container for common services shared by both client and server.
 * Contains all services from the common package.
 *
 * Note: Constructor accepts World<any> because TypeScript generics are invariant.
 * ServerWorld (World<ServerRegistry>) and ClientWorld (World<ClientRegistry>) cannot
 * be assigned to World<CommonRegistry> even though their registries extend CommonRegistry.
 * Server/client base classes override getWorld() for properly typed access.
 *
 * TODO: The WorldService here is redundant - server/client base classes override
 * getWorld() to use their specific WorldService (ServerWorldService/ClientWorldService).
 * Consider removing WorldService from CommonServiceContainer entirely.
 */
export class CommonServiceContainer {
  public readonly eventBus: EventBusService;
  public readonly gameTime: GameTimeService;
  public readonly input: InputService;
  public readonly mapData: MapDataService;
  public readonly messageQueue: MessageQueueService;
  public readonly simulation: SimulationService;
  public readonly terrain: TerrainService;
  public readonly world: WorldService;
  public readonly combat: CombatService;
  public readonly speed: SpeedService;
  public readonly isClient: boolean;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(world: World<any>, isClient: boolean) {
    this.isClient = isClient;
    this.eventBus = new EventBusService();
    this.gameTime = new GameTimeService();
    this.input = new InputService();
    this.mapData = new MapDataService();
    this.messageQueue = new MessageQueueService();
    this.simulation = new SimulationService();
    this.terrain = new TerrainService();
    this.world = new WorldService(world as World<CommonRegistry>);
    this.combat = new CombatService();
    this.speed = new SpeedService();
  }
}
